<app-dashboard-layout [loading]="loading" [downloader]="downloader" [dialog]="dialog">
  <section class="bg-white border rounded-md p-4">
    <header class="border-b flex text-lg w-full pb-4 gap-8 md:text-xl grid gap-4 grid-cols-2">
      <div class="">
        Order History
      </div>
      <div class="text-right">
        
      </div>
    </header>

    <app-notification-alert [data]="apiService.notification"></app-notification-alert>
    <div *ngIf="skeletonLoader" class="grid pb-4 gap-4 gap-8 grid-cols-1 md:grid-cols-4">
      <div *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]" class="border rounded-md bg-gray-300 h-20 animate-pulse"></div>
    </div>
    <table *ngIf="!skeletonLoader && orderHistory.length > 0" class="w-full text-sm text-left text-gray-600 md:block">
      <thead class="text-xs text-gray-700 bg-primary/5">
          <tr>
              <th scope="col" class="py-3 px-6">
                  Order ID
              </th>                                
              <th scope="col" class="py-3 px-6">        
                  Date Ordered
              </th>                               
              <th scope="col" class="py-3 px-6">        
                  Session
              </th>                              
              <th scope="col" class="py-3 px-6">        
                  Total Amount
              </th>                              
              <th scope="col" class="py-3 px-6">        
                  Paid Amount
              </th>                              
              <th scope="col" class="py-3 px-6">        
                  Pending Fee
              </th>                              
              <th scope="col" class="py-3 px-6">        
                  Payment Status
              </th>
              <th scope="col" class="py-3 px-6"></th>
              <th scope="col" class="py-3 px-6"></th>
          </tr>
      </thead>
      <tbody>
          <tr *ngFor="let item of orderHistory; let i = index" class="bg-white border-b" >
              <td class="py-4 px-6">
                  {{item.CollectionID}}
              </td>
              <td class="py-4 px-6">
                  {{getDate(item.OrderDate)}}
              </td>
              <td class="py-4 px-6">
                  {{item.Session}}
              </td>
              <td class="py-4 px-6 text-right">
                ₦ {{item.TotalAmount.toLocaleString()}}
              </td>
              <td class="py-4 px-6 text-right">
                ₦ {{item.PaidAmount.toLocaleString()}}
              </td>
              <td class="py-4 px-6 text-right">
                ₦ {{item.PendingFee.toLocaleString()}}
              </td>
              <td class="py-4 text-center text-white">
                <span [class]="'px-2 py-1 rounded-full '+ getStatusClass(item)">{{item.PaymentStatus}}</span>
              </td>

              <td class="py-4 px-6">
                <app-button-primary [routerLink]="'/purchases/order-details/'+item.CollectionID">
                   View Order
                  </app-button-primary>
              </td>
              <td *ngIf="item.PendingFee > 0" class="py-4 px-6">
                <app-button-primary [routerLink]="'/payments/tranzgate/'+getEncodedSession(item.Session)">
                   Make Payment
                  </app-button-primary>
              </td>
              <td *ngIf="item.PendingFee <= 0" class="py-4 px-6">
                <app-button-primary [outline]="true" (click)="printReciepts(item.CollectionID)">
                   Print Receipt
                </app-button-primary>
              </td>
          </tr>
      </tbody>
  </table>
  <app-no-content *ngIf="!skeletonLoader && orderHistory.length == 0"></app-no-content>


  </section>
</app-dashboard-layout>
